import type { CityKey } from "@/lib/citiesData";
import { webDesignTiers, leadGenTiers } from "./pricingData";
function starterInvestment(context: string, service: "seo" | "web-design") {
  const website = service === "web-design";
  return {
    context, service, priceRange: website ? `From ${webDesignTiers[0].price} one-time` : `From ${leadGenTiers[0].price}/month`,
    bullets: website ? ["4 pages: Home, About, Services, Contact", "Mobile-friendly design, SEO foundation, contact form and click-to-call", "1 year of hosting and a built-in traffic dashboard"] : leadGenTiers[0].features,
    note: website ? "Typical websites are built in less than 7 business days. Compare all website packages on the pricing page." : "Starter Marketing includes Local SEO and Google Maps. AI search and social media begin with Growth; PPC and reputation management are Expert-only.",
  };
}
export function getCityInvestment(_citySlug: CityKey, service: "seo" | "web-design", cityName: string) {
  return starterInvestment(cityName, service);
}
export function getIndustryInvestment(_industrySlug: string, service: "seo" | "web-design" | "local-seo" | "ppc", industryName: string, _industryShortName: string) {
  return starterInvestment(`Colorado ${industryName}`, service === "web-design" ? "web-design" : "seo");
}
